const ErrorIconComponent = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="105"
            height="97"
            viewBox="0 0 105 97"
            fill="none"
        >
            <g clipPath="url(#clip0_2901_19175)">
                <path
                    d="M0.629883 96.2192L0.687156 96.3338H104.306L104.37 96.2192L52.4999 0.357422L0.629883 96.2192Z"
                    fill="#DDDEE1"
                />
                <path
                    d="M52.6782 34.6891V69.6954"
                    stroke="white"
                    strokeWidth="7.33"
                    strokeMiterlimit="10"
                />
                <path
                    d="M55.1283 80.6028C55.1601 80.4373 55.1728 80.2591 55.1728 80.0746C55.1728 79.8901 55.1601 79.7055 55.1283 79.5401C54.9501 78.541 54.2564 77.9301 53.2828 77.771C53.1174 77.7455 52.9455 77.7328 52.761 77.7328C52.5764 77.7328 52.3919 77.7455 52.2201 77.7773C51.2464 77.9364 50.5592 78.5537 50.3746 79.5464C50.3428 79.7119 50.3301 79.8901 50.3301 80.081C50.3301 80.2719 50.3428 80.4437 50.3746 80.6092C50.5528 81.6019 51.2464 82.2128 52.2201 82.3782C52.3919 82.4101 52.5764 82.4228 52.761 82.4228C52.9455 82.4228 53.1174 82.4101 53.2828 82.3846C54.2564 82.2255 54.9501 81.6082 55.1283 80.6155V80.6028Z"
                    stroke="white"
                    strokeWidth="7.33"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_2901_19175">
                    <rect width="105" height="97" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const ErrorIconImage = ErrorIconComponent;
